(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("@ied/icon"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "@ied/icon"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("styled-components"), require("@ied/icon")) : factory(root["react"], root["styled-components"], root["@ied/icon"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _Styled = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavCard = function NavCard(_ref) {
  var title = _ref.title,
      description = _ref.description,
      icon = _ref.icon,
      style = _ref.style,
      className = _ref.className,
      onClick = _ref.onClick,
      notifications = _ref.notifications,
      _ref$notificationsMax = _ref.notificationsMax,
      notificationsMax = _ref$notificationsMax === void 0 ? 10 : _ref$notificationsMax;
  return /*#__PURE__*/_react["default"].createElement(_Styled.Container, {
    style: style,
    className: className,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_Styled.Box, {
    margin: !description
  }, icon && /*#__PURE__*/_react["default"].createElement(_Styled.Icon, null, icon), !!notifications && /*#__PURE__*/_react["default"].createElement(_Styled.Notifications, null, notifications < notificationsMax ? notifications : '+')), /*#__PURE__*/_react["default"].createElement(_Styled.Title, null, title), description && /*#__PURE__*/_react["default"].createElement(_Styled.Description, null, description));
};

var _default = NavCard;
exports["default"] = _default;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = exports.Box = exports.Icon = exports.Description = exports.Title = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(__webpack_require__(3));

var _icon = _interopRequireDefault(__webpack_require__(4));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-radius: 22px;\n  height: 22px;\n  width: 22px;\n  background-color: #8bc34a;\n  line-height: 22px;\n  vertical-align: middle;\n  text-align: center;\n  font-size: 12px;\n  color: white;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 46px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  font-size: 12px;\n  color: #545151;\n  font-weight: lighter;\n  line-height: 15px;\n  max-height: 45px;\n  margin-bottom: 1px;\n  margin-top: 8px;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  margin: 5px 0 0;\n  font-weight: bold;\n  overflow: hidden;\n  line-height: 15px;\n  width: 100%;\n  max-height: 30px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: Open sans, sans-serif;\n  text-align: center;\n  margin: 10px;\n  padding: 10px;\n  width: 160px;\n  height: 160px;\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  cursor: pointer;\n  background-color: transparent;\n  transition: background-color 0.3s;\n  user-select: none;\n  color: black;\n  &:hover {\n    background-color: #e2e1e1;\n  }\n  &:active {\n    background-color: #f1f1f1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents["default"].div(_templateObject());

exports.Container = Container;

var Title = _styledComponents["default"].h3(_templateObject2());

exports.Title = Title;

var Description = _styledComponents["default"].p(_templateObject3());

exports.Description = Description;
var Icon = (0, _styledComponents["default"])(_icon["default"])(_templateObject4());
exports.Icon = Icon;

var Box = _styledComponents["default"].div(_templateObject5(), function (_ref) {
  var margin = _ref.margin;
  return margin ? '30px' : '5px';
});

exports.Box = Box;

var Notifications = _styledComponents["default"].div(_templateObject6());

exports.Notifications = Notifications;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// dist/bundle.js